import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root',
})
export class SeoService {
    private staticTagsInitialized = false;

    constructor(
        private meta: Meta,
        private title: Title,
    ) {}

    updateSeo(data: IUpdateSeoModel): void {
        this.initializeStaticTags();

        // Normal SEO
        if (data.title) {
            this.title.setTitle(data.title);
        }
        if (data.description) {
            this.updateTag('name', 'description', data.description);
        }

        // Facebook
        this.updateTag('property', 'og:title', data.title);
        this.updateTag('property', 'og:description', data.description);
        this.updateTag('property', 'og:image', data.image);
        this.updateTag('property', 'og:url', data.url);

        // Twitter
        this.updateTag('name', 'twitter:card', data.image ? 'summary_large_image' : 'summary');
        this.updateTag('name', 'twitter:title', data.title);
        this.updateTag('name', 'twitter:description', data.description);
        this.updateTag('name', 'twitter:image', data.image);
        this.updateTag('name', 'twitter:url', data.url);
    }

    private initializeStaticTags(): void {
        if (this.staticTagsInitialized) {
            return;
        }

        this.updateTag('property', 'og:type', 'website');

        this.staticTagsInitialized = true;
    }

    private updateTag(attr: 'name' | 'property', key: string, value?: string): void {
        const selector = `${attr}="${key}"`;

        if (value) {
            this.meta.updateTag({ [attr]: key, content: value });
        } else {
            this.meta.removeTag(selector);
        }
    }
}

interface IUpdateSeoModel {
    title?: string;
    description?: string;
    image?: string;
    url?: string;
}
